import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
import { useState } from "react";
import { useOnboarding } from "./onboarding-provider";
import {
  Step1,
  Step2,
  Step3,
  Step4,
  Step5,
  Step6,
  Step7,
} from "./onboarding-steps";

const stepImageMap = {
  1: "/onboarding-modal/step-1a.webp",
  2: "/onboarding-modal/step-2.webp",
  3: "/onboarding-modal/step-3.webp",
  4: "/onboarding-modal/step-4.webp",
  5: "/onboarding-modal/step-5.webp",
  6: "/onboarding-modal/step-6.webp",
  7: "/onboarding-modal/step-7.webp",
};

export default function OnboardingWizard() {
  const {
    currentStep,
    nextStep,
    prevStep,
    isStepComplete,
    totalSteps,
    handleOnFinish,
    isSaving,
  } = useOnboarding();

  const [isTransitioning, setIsTransitioning] = useState(false);
  // const [displayStep, setDisplayStep] = useState(currentStep);

  // useEffect(() => {
  //   if (currentStep !== displayStep) {
  //     setIsTransitioning(true);
  //     const timer = setTimeout(() => {
  //       setDisplayStep(currentStep);
  //       setIsTransitioning(false);
  //     }, 300); // Match this with the CSS transition duration
  //     return () => clearTimeout(timer);
  //   }
  // }, [currentStep, displayStep]);

  // useEffect(() => {
  //   if (currentStep !== displayStep) {
  //     if (isStepComplete(currentStep)) {
  //       setDisplayStep(currentStep);
  //     }
  //   }
  // }, [currentStep, displayStep]);

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <Step1 />;
      case 2:
        return <Step2 />;
      case 3:
        return <Step3 />;
      case 4:
        return <Step4 />;
      case 5:
        return <Step5 />;
      case 6:
        return <Step6 />;
      case 7:
        return <Step7 />;
      default:
        return null;
    }
  };

  const isLastStep = currentStep === totalSteps;
  const canProceed = isStepComplete(currentStep);

  return (
    <div className="grid grid-cols-2">
      <div className="flex flex-col justify-between">
        <div
          className={`min-h-[280px] relative p-4 md:p-6 ${
            isTransitioning ? "opacity-0" : "opacity-100"
          } transition-opacity duration-300`}
        >
          {renderStepContent()}
        </div>

        {/* Navigation buttons */}
        <div className="flex justify-between mt-5 px-4 md:px-6 pb-4 md:pb-6">
          <Button
            variant="outline"
            onClick={prevStep}
            disabled={currentStep === 1 || isTransitioning}
            className={currentStep === 1 ? "invisible" : ""}
          >
            <ChevronLeft className="h-4 w-4" />
            Back
          </Button>

          {!isLastStep ? (
            <Button
              onClick={nextStep}
              disabled={!canProceed || isTransitioning}
            >
              Next
              <ChevronRight className="h-4 w-4" />
            </Button>
          ) : (
            <Button
              disabled={!canProceed || isTransitioning || isSaving}
              onClick={() => {
                handleOnFinish("complete");
              }}
            >
              {isSaving ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <>
                  Finish
                  <ChevronRight className="h-4 w-4" />
                </>
              )}
            </Button>
          )}
        </div>
      </div>

      <div
        className={cn(
          "bg-secondary relative transition-opacity duration-300",
          isTransitioning ? "opacity-0" : "opacity-100"
        )}
      >
        <div
          className={cn(
            "absolute top-4 right-4 font-medium text-sm text-muted-foreground/70 ",
            currentStep > 4 && "right-10"
          )}
        >
          {currentStep} of {totalSteps}
        </div>

        <img
          src={stepImageMap[currentStep as keyof typeof stepImageMap]}
          alt="Onboarding Step"
          className={cn(
            "w-full h-full object-cover",
            currentStep === 3 && "object-left-top"
          )}
        />
      </div>
    </div>
  );
}
